var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _circle, _path10, _path11, _path12, _circle2, _path13, _path14, _circle3, _circle4, _rect2, _path15, _path16, _path17, _path18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedalhaFantasia3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 260,
    viewBox: "0 0 214 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 213,
    height: 260,
    rx: 8,
    fill: "#ECE6F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.682 112.44C170.682 149.683 142.821 168.305 109.706 179.106C107.972 179.656 106.089 179.629 104.373 179.031C71.1786 168.305 43.3175 149.683 43.3175 112.44V60.2984C43.3175 58.3228 44.1562 56.4282 45.649 55.0313C47.1419 53.6344 49.1666 52.8496 51.2778 52.8496C67.1984 52.8496 87.0992 43.9111 100.95 32.589C102.637 31.2408 104.782 30.5 107 30.5C109.218 30.5 111.363 31.2408 113.05 32.589C126.98 43.9856 146.802 52.8496 162.722 52.8496C164.833 52.8496 166.858 53.6344 168.351 55.0313C169.844 56.4282 170.682 58.3228 170.682 60.2984V112.44Z",
    fill: "url(#paint0_linear_2162_30784)",
    stroke: "url(#paint1_linear_2162_30784)",
    strokeWidth: 3.91429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.979 125.416C117.946 125.416 126.951 126.679 133.449 128.709C136.701 129.726 139.299 130.927 141.075 132.239C142.859 133.557 143.737 134.928 143.737 136.279C143.737 137.63 142.86 139.001 141.075 140.32C139.299 141.632 136.701 142.832 133.449 143.848C126.951 145.879 117.946 147.142 107.979 147.142C98.013 147.142 89.0078 145.879 82.5096 143.848C79.2578 142.832 76.6585 141.632 74.8827 140.32C73.0981 139.001 72.2206 137.63 72.2206 136.279C72.2207 134.928 73.0983 133.557 74.8827 132.239C76.6585 130.927 79.2578 129.726 82.5096 128.709C89.0078 126.679 98.0131 125.416 107.979 125.416Z",
    fill: "#232323",
    stroke: "#100F11",
    strokeWidth: 0.905263
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.526 132.657C111.114 132.657 114.344 133.16 116.661 133.959C117.821 134.359 118.728 134.825 119.336 135.32C119.946 135.818 120.2 136.298 120.2 136.731C120.2 137.165 119.946 137.644 119.336 138.143C118.728 138.638 117.821 139.104 116.661 139.504C114.344 140.303 111.114 140.805 107.526 140.805C103.938 140.805 100.709 140.303 98.3922 139.504C97.2318 139.104 96.325 138.638 95.7174 138.143C95.1064 137.644 94.8522 137.165 94.8522 136.731C94.8522 136.298 95.1064 135.818 95.7174 135.32C96.325 134.825 97.2318 134.359 98.3922 133.959C100.709 133.16 103.938 132.657 107.526 132.657Z",
    fill: "#D8BB00",
    stroke: "#100F11",
    strokeWidth: 0.905263
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.979 148.5C127.977 148.5 144.189 143.231 144.189 136.732C144.189 130.232 127.977 124.963 107.979 124.963C87.9804 124.963 71.7684 130.232 71.7684 136.732C71.7684 143.231 87.9804 148.5 107.979 148.5Z",
    stroke: "#100F11",
    strokeWidth: 5.3013,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.98 141.439C115.979 141.439 122.464 139.332 122.464 136.732C122.464 134.132 115.979 132.024 107.98 132.024C99.9802 132.024 93.4954 134.132 93.4954 136.732C93.4954 139.332 99.9802 141.439 107.98 141.439Z",
    stroke: "#100F11",
    strokeWidth: 5.3013,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.98 136.731H108.014H107.98Z",
    fill: "#232323"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M107.98 136.731H108.014",
    stroke: "#100F11",
    strokeWidth: 5.3013,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M115.278 90.5068L123.654 99.8682V112.09L119.27 114.282L115.946 108.584L115.821 108.369L115.575 108.336L104.404 106.812L97.8256 105.041L94.0638 101.442L91.2123 90.5068H115.278Z",
    fill: "#BB0000",
    stroke: "#100F11",
    strokeWidth: 1.01849
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5 101.5C92.8654 104.385 109.794 104.04 116.453 101.5C123.112 98.9598 122.5 111.5 120 114.5C117.5 117.5 118 114 114.5 116C111 118 116.676 115.034 117 114L116.453 111.176L113.5 107.5L107 108L101.5 107.5L91.5 101.5Z",
    fill: "#BB5A00"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M102.789 99.152H102.809M106.86 119.509C107.878 118.491 109.14 117.473 111.95 117.473M111.95 117.473C109.14 117.473 107.878 116.455 106.86 115.438M111.95 117.473C115.459 117.473 118.825 116.079 121.306 113.598C123.788 111.116 125.182 107.751 125.182 104.241C125.182 100.732 123.788 97.3662 121.306 94.8848C118.825 92.4033 115.459 91.0092 111.95 91.0092H89.3269C88.6681 91.0126 88.0155 90.8821 87.4087 90.6255C86.8019 90.3689 86.2537 89.9916 85.7972 89.5165C85.3408 89.0414 84.9858 88.4785 84.7537 87.8619C84.5216 87.2453 84.4173 86.588 84.4471 85.9299C84.477 85.2717 84.6403 84.6265 84.9273 84.0335C85.2142 83.4405 85.6188 82.912 86.1163 82.4802C86.6139 82.0483 87.1941 81.7222 87.8216 81.5216C88.4491 81.3209 89.1109 81.25 89.7666 81.3131L102.327 82.4551C103.663 82.5754 105.004 82.2906 106.176 81.6378C107.348 80.9849 108.296 79.9943 108.896 78.7949M111.95 117.473C113.299 117.473 114.594 116.937 115.548 115.983C116.503 115.028 117.039 113.734 117.039 112.384C117.039 111.034 116.503 109.74 115.548 108.785C114.594 107.831 113.299 107.295 111.95 107.295H104.825C101.045 107.295 97.4209 105.793 94.7485 103.121C92.0761 100.449 90.5748 96.8242 90.5748 93.0449V91.0092",
    stroke: "#100F11",
    strokeWidth: 4.07141,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M108.896 91.0093C110.233 93.5153 110.932 96.3119 110.932 99.1521C110.932 101.992 110.233 104.789 108.896 107.295M112.968 107.295C117.039 107.295 122.128 99.1521 121.11 95.0807",
    stroke: "#100F11",
    strokeWidth: 4.07141,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.6211,
    cy: 120.437,
    r: 2.71579,
    fill: "#2EDD79"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6211 124.058C65.6209 124.058 67.2421 122.437 67.2421 120.437C67.2421 118.437 65.6209 116.816 63.6211 116.816C61.6212 116.816 60 118.437 60 120.437C60 122.437 61.6212 124.058 63.6211 124.058Z",
    stroke: "#100F11",
    strokeWidth: 1.81053,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2421 120.437V105.953V120.437Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2421 120.437V105.953",
    stroke: "#100F11",
    strokeWidth: 1.81053,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.189,
    cy: 113.195,
    r: 2.71579,
    fill: "#2EDD79"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M144.19 116.816C146.189 116.816 147.811 115.195 147.811 113.195C147.811 111.195 146.189 109.574 144.19 109.574C142.19 109.574 140.568 111.195 140.568 113.195C140.568 115.195 142.19 116.816 144.19 116.816Z",
    stroke: "#100F11",
    strokeWidth: 1.81053,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M147.811 113.195V98.7104L154.147 102.332",
    stroke: "#100F11",
    strokeWidth: 1.81053,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 127.895,
    cy: 76.0791,
    r: 2.71579,
    fill: "#2EDD79"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 138.758,
    cy: 74.2685,
    r: 2.71579,
    fill: "#2EDD79"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 130.391,
    y: 64.2222,
    width: 10.7813,
    height: 3.19321,
    transform: "rotate(-6.77552 130.391 64.2222)",
    fill: "#2EDD79"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M130.61 76.0789V64.3105L141.474 62.5V74.2684M130.61 67.9316L141.474 66.1211",
    stroke: "#100F11",
    strokeWidth: 1.81053,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M127.895 78.7949C129.395 78.7949 130.611 77.579 130.611 76.0791C130.611 74.5792 129.395 73.3633 127.895 73.3633C126.395 73.3633 125.179 74.5792 125.179 76.0791C125.179 77.579 126.395 78.7949 127.895 78.7949Z",
    stroke: "#100F11",
    strokeWidth: 1.81053,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M138.758 76.9843C140.258 76.9843 141.474 75.7684 141.474 74.2685C141.474 72.7686 140.258 71.5527 138.758 71.5527C137.258 71.5527 136.042 72.7686 136.042 74.2685C136.042 75.7684 137.258 76.9843 138.758 76.9843Z",
    stroke: "#100F11",
    strokeWidth: 1.81053,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6264 202.136V222.5H76.8026L66.4517 207.565H66.2628V222.5H63.1903V202.136H66.0341L76.3949 217.091H76.5838V202.136H79.6264ZM83.8697 222.5V207.227H86.8427V222.5H83.8697ZM84.1481 205.189L86.4748 200.605H89.6069L86.5245 205.189H84.1481ZM103.908 207.227L98.3693 222.5H95.1875L89.6392 207.227H92.831L96.6989 218.98H96.858L100.716 207.227H103.908ZM112.765 222.808C111.26 222.808 109.964 222.487 108.877 221.844C107.796 221.194 106.961 220.283 106.371 219.109C105.788 217.929 105.496 216.547 105.496 214.963C105.496 213.399 105.788 212.02 106.371 210.827C106.961 209.634 107.783 208.702 108.837 208.033C109.898 207.363 111.137 207.028 112.556 207.028C113.417 207.028 114.253 207.171 115.061 207.456C115.87 207.741 116.596 208.188 117.239 208.798C117.882 209.408 118.389 210.2 118.76 211.175C119.132 212.143 119.317 213.319 119.317 214.705V215.759H107.176V213.531H116.404C116.404 212.749 116.245 212.056 115.926 211.453C115.608 210.843 115.161 210.363 114.584 210.011C114.014 209.66 113.345 209.484 112.576 209.484C111.74 209.484 111.011 209.69 110.388 210.101C109.772 210.505 109.294 211.036 108.956 211.692C108.625 212.341 108.459 213.047 108.459 213.81V215.55C108.459 216.571 108.638 217.439 108.996 218.155C109.361 218.871 109.868 219.418 110.517 219.795C111.167 220.167 111.926 220.352 112.794 220.352C113.358 220.352 113.872 220.273 114.336 220.114C114.8 219.948 115.201 219.703 115.539 219.378C115.877 219.053 116.135 218.652 116.314 218.175L119.128 218.682C118.903 219.51 118.498 220.236 117.915 220.859C117.338 221.476 116.613 221.956 115.738 222.301C114.869 222.639 113.878 222.808 112.765 222.808ZM125.589 202.136V222.5H122.616V202.136H125.589ZM144.048 222.778C142.683 222.778 141.463 222.543 140.389 222.072C139.322 221.602 138.477 220.949 137.854 220.114C137.237 219.272 136.906 218.297 136.859 217.19H139.982C140.021 217.794 140.223 218.317 140.588 218.761C140.959 219.199 141.443 219.537 142.04 219.776C142.636 220.014 143.299 220.134 144.028 220.134C144.83 220.134 145.54 219.994 146.156 219.716C146.779 219.437 147.267 219.05 147.618 218.553C147.969 218.049 148.145 217.469 148.145 216.812C148.145 216.13 147.969 215.53 147.618 215.013C147.273 214.489 146.766 214.078 146.097 213.78C145.434 213.482 144.632 213.332 143.69 213.332H141.97V210.827H143.69C144.446 210.827 145.109 210.691 145.679 210.419C146.256 210.147 146.706 209.769 147.031 209.286C147.356 208.795 147.518 208.222 147.518 207.565C147.518 206.936 147.376 206.389 147.091 205.925C146.813 205.454 146.415 205.086 145.898 204.821C145.387 204.556 144.784 204.423 144.088 204.423C143.425 204.423 142.805 204.546 142.229 204.791C141.659 205.03 141.195 205.375 140.837 205.825C140.479 206.269 140.286 206.803 140.26 207.426H137.287C137.32 206.326 137.645 205.358 138.261 204.523C138.884 203.687 139.706 203.035 140.727 202.564C141.748 202.093 142.882 201.858 144.128 201.858C145.434 201.858 146.561 202.113 147.509 202.624C148.463 203.127 149.199 203.8 149.716 204.642C150.24 205.484 150.498 206.405 150.491 207.406C150.498 208.546 150.18 209.514 149.537 210.31C148.901 211.105 148.052 211.639 146.991 211.911V212.07C148.344 212.275 149.391 212.812 150.134 213.68C150.883 214.549 151.254 215.626 151.247 216.912C151.254 218.032 150.942 219.036 150.312 219.925C149.689 220.813 148.838 221.512 147.757 222.023C146.677 222.527 145.44 222.778 144.048 222.778Z",
    fill: "#4C4452"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2162_30784",
    x1: 107,
    y1: 30.5,
    x2: 107,
    y2: 179.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0164"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519231,
    stopColor: "#FDFC01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2162_30784",
    x1: 107,
    y1: 30.5,
    x2: 107,
    y2: 179.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FECC01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE0222"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalhaFantasia3);
export default __webpack_public_path__ + "static/media/Medalha_fantasia_3.5cbed487a8b0aced2b748bbdf8ac795c.svg";
export { ForwardRef as ReactComponent };